import { memo, useMemo } from "react";

// Servisni sloj
import { FleetVehicleStatusEnum } from "services/api/fleet/vehicles/types";

// UI
import { Breadcrumb } from "ui/components/Breadcrumb";
import { BreadcrumbItem } from "ui/components/Breadcrumb/types";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import { SIDEBAR_ITEM_FLEET_VEHICLE } from "app/components/Sidebar/consts";

import { VehicleStatusEditCard } from "../VehicleStatusEditCard";
import { VehicleTabHeaderProps } from "./types";

/**
 * Zaglavlje tabova vozila — slika, naslov sa nazivom vozila, značka statusa i putanja.
 *
 * Status stoji uz naslov na svakom tabu, ne samo na detaljima: kad se gleda povijest ili
 * troškovi, prvo pitanje je i dalje je li vozilo dostupno. Značka je ista komponenta kao
 * na detaljima, pa se status odavde i mijenja.
 */
const VehicleTabHeader: React.FC<VehicleTabHeaderProps> = (props) => {
  const { vehicleId, vehicle, title, icon, iconColor, onStatusChange, children } = props;

  const breadcrumbs: BreadcrumbItem[] = useMemo(
    () => [
      {
        text: SIDEBAR_ITEM_FLEET_VEHICLE.text,
        route: SIDEBAR_ITEM_FLEET_VEHICLE.route,
      },
    ],
    []
  );

  return (
    <PageHeader>
      <div className="flex items-center justify-between">
        <div className="flex gap-3">
          {vehicle.defaultImage && (
            <img
              src={vehicle.defaultImage}
              alt={vehicle.name ?? ""}
              title={vehicle.name ?? ""}
              className="h-12 w-12 object-contain rounded-full"
            />
          )}
          <div>
            <div className="flex gap-2 items-center">
              <PageTitle
                title={`${title} ${vehicle.name ? `[${vehicle.name}]` : ""}`}
                icon={icon}
                iconColor={iconColor}
              />
              {/* Dok se vozilo dohvaća status je prazan — značka se tada ne crta. Uz
                  pretpostavljeno "Slobodno" bi na trenutak pisao krivi status. */}
              {vehicle.status && (
                <div>
                  <VehicleStatusEditCard
                    vehicleId={vehicleId}
                    currentStatus={vehicle.status as FleetVehicleStatusEnum}
                    onStatusChange={onStatusChange}
                  />
                </div>
              )}
            </div>
            <Breadcrumb items={breadcrumbs} />
          </div>
        </div>

        {children && <div className="flex items-center gap-2">{children}</div>}
      </div>
    </PageHeader>
  );
};

export default memo(VehicleTabHeader);
